import UserApiKeySettingsModelBase from '../_generated/modelBases/user-api-key-settings-model-base';

export default class UserApiKeySettingsModel extends UserApiKeySettingsModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
